export default __webpack_public_path__ + "static/media/world.9c9f39eb.svg";